import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GoldenFilledSvg from "@ant-design/icons-svg/es/asn/GoldenFilled";
import AntdIcon from '../components/AntdIcon';
var GoldenFilled = function GoldenFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: GoldenFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(GoldenFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'GoldenFilled';
}
export default RefIcon;